export default __webpack_public_path__ + "static/media/gallery_10.cc60cf2a.jpg";